<!--  -->
<template>
  <div class="title">
    <van-sticky>
      <van-nav-bar
        :title="showTitlte"
        left-text=""
        :left-arrow="showBack"
        :fixed="true"
        z-index="99"
        :placeholder="true"
        :border="false"
        :safe-area-inset-top="true"
        :class="{ bgcolor: bgpan == '1' }"
        @click-left="fanhui()"
      >
        <template #right>
          <div class="rightbtn">
            <!-- <van-icon
              v-if="btns.includes('001')"
              @click="clickbtns(1)"
              size="1.5rem"
              name="chat-o"
              :dot="dian"
            /> -->
            <!-- <van-badge class="dian" :dot="dian" v-if="btns.includes('001')">
              <img
                class="tupian"
                @click="clickbtns(1)"
                src="../assets/images/消息.png"
                alt=""
              />
            </van-badge> -->
            <span v-if="btns.includes('002')" @click="edit()">退出系统</span>
          </div>
        </template>
        <!-- <template #left>
          <div v-if="showBack" @click.stop="fanhui()">
            <span v-if="bgpan == 1" class="bai">返回</span>
            <span v-else class="hei">返回</span>
          </div>
        </template> -->
      </van-nav-bar>
    </van-sticky>
  </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapGetters } from "vuex";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      showTitlte: "", //标题
      showBack: "", //是否显示返回按钮
      btns: [], //右侧按钮的标识集合
      dians: false, //是否显示校友信息小红点
      bgpan: "0", //判断背景颜色
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["dian"]),
    newData() {
      return this.$store.state.bgpan;
    },
  },
  //监控data中的数据变化
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val);
        // console.log(oldVal);
        this.showTitlte = val.meta.title;
        this.showBack = val.meta.show;
        this.btns = val.meta.btns ? val.meta.btns : [];
        // this.dian = this.$store.getters.dian;
        this.bgpan = this.$store.getters.bgpan;
        // console.log(this.bgpan);
      },
      // 深度观察监听
      deep: true,
      immediate: true, //加这个就可以在刷新时也监听到相应页面的路由
    },
    newData: {
      handler(val) {
        this.bgpan = this.$store.getters.bgpan;
      },
    },

    // dian(clickdic) {
    //   //   console.log(clickdic);
    // },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {
    fanhui() {
      // console.log(this.$route.meta);
      //是否监听 true自定义返回页面，false默认返回上一页
      if (this.$route.meta.listen) {
        console.log(1);
        this.$store.commit("SET_LEFTBTNCLICK");
      } else {
        console.log(2);
        this.$router.back(-1);
      }
    },
    clickbtns(btn) {
      //   console.log(btn);
      this.$store.commit("SET_RIGHTBTNCLICK", btn);
    },
    edit() {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "确定退出系统吗？",
        })
        .then(() => {
          sessionStorage.clear();
          this.$toast("退出成功！");
          this.$router.push("/login");
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.rightbtn {
  width: 3rem;
}
.bai {
  color: #fff;
}
.dian {
  width: 1.5rem;
  display: flex;
}
.tupian {
  width: 1.5rem;
}
.title {
  height: 2rem;
  width: 100%;
  z-index: 9999;
  border-bottom: 0.04rem solid #038be7;
}
/deep/.van-nav-bar .van-icon {
  color: #5c5e6a;
}
/deep/.van-nav-bar--fixed {
  border-bottom: 0.04rem solid #efefef;
  height: 2rem;
}
/deep/.van-nav-bar--content {
  // height: 2rem !important;
}
.bgcolor {
  /deep/.van-nav-bar--fixed {
    background-color: #038be7;
    height: 2rem;
  }
  /deep/.van-nav-bar__title {
    color: #fff;
  }
  /deep/.van-nav-bar .van-icon {
    color: #fff;
  }
  /deep/.van-nav-bar--fixed {
    border-bottom: 0.04rem solid #038be7;
  }
}
/deep/.van-nav-bar__title {
  font-size: 0.64rem;
}
</style>